module.exports = __webpack_public_path__ + "media/images/athletes/1475-698dad024616f46cb0f5c72aa4f3a125.png";